const ANIMATION_DURATION = 1000

const els = {
	cards: document.querySelectorAll('.js-stat-highlight-card'),
	cardsProgress: document.querySelectorAll('.js-stat-highlight-card-progress'),
	cardsProgressText: document.querySelectorAll('.js-stat-highlight-card-progress-text'),
}

// Animate the progress
const animateProgress = ({
	progressEl,
	progressTextEl,
	progressStart,
	progressEnd
}) => {
  let startTimestamp = null

  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp

    const progress = Math.min((timestamp - startTimestamp) / ANIMATION_DURATION, 1)
    const value = Math.floor(progress * (progressEnd - progressStart) + progressStart)

    progressEl.style.setProperty('--progress', value)
    progressTextEl.textContent = `${value}%`

    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }

  window.requestAnimationFrame(step)
}

// Trigger progress animation once it is in the viewport
const onIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
			const element = entry.target
			const index = Array.from(element.parentNode.children).indexOf(element)
			const progressEl = els.cardsProgress[index]
			const progressTextEl = els.cardsProgressText[index]
			const progressStart = 0
			const progressEnd = parseInt(progressEl.dataset.progress)
		
      animateProgress({
				progressEl,
				progressTextEl,
				progressStart,
				progressEnd 
			})
      observer.unobserve(entry.target)
    }
  })
}

const observer = new IntersectionObserver(onIntersection)

els.cards.forEach((el, i) => observer.observe(el))